import React, { Component } from "react";
import { Container } from "react-bootstrap";
import { withRouter } from "react-router-dom";
import "./_cbse_foundation.scss";

import SyllabusPdfTable from "../ChapterWiseLearningEamcet/syllabusPdfTable";

class CBSEChapterDetailsSection extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showShortNotes: false,
            showRevisionalPdf: false,
            shortNotesstudyMaterial: "",
            revisionalPdfUrl: ""
        };
    }

    goToTab = (tabName) => {
        const { classId, subjectId, chapterId } = this.props.match.params;

        this.props.history.push(
            `/cbse/class-${classId}/subject-${subjectId}/chapter-${chapterId}/${tabName}`
        );
    };

    componentDidUpdate(prevProps) {
        const { tab } = this.props.match.params;

        if (prevProps.match.params.tab !== tab) {
            if (tab === "short-notes" && this.props.chapterData.shortNotes) {
                this.setState({
                    showShortNotes: true,
                    shortNotesstudyMaterial: this.props.chapterData.shortNotes
                });
            }

            if (tab === "revisional-material" && this.props.chapterData.revisionalMaterial) {
                this.setState({
                    showRevisionalPdf: true,
                    revisionalPdfUrl: this.props.chapterData.revisionalMaterial
                });
            }
        }
    }

    render() {
        const { tab } = this.props.match.params;

        const chapterData = this.props.chapterData || {};

        const {
            previousPapers = [],
            shortNotes = null,
            revisionalMaterial = null,
            videos = [],
            practise = []
        } = chapterData;

        return (
            <Container className="chapter-details-wrapper mt-4">

                {/* TAB HEADERS */}
                <div className="tabs-container">

                    {/* <div
                        className={`tab-item ${tab === "previous-papers" ? "active" : ""}`}
                        onClick={() => this.goToTab("previous-papers")}
                    >
                        Previous Papers
                    </div> */}

                    <div
                        className={`tab-item ${tab === "short-notes" ? "active" : ""}`}
                        onClick={() => this.goToTab("short-notes")}
                    >
                        Short Notes
                    </div>

                    <div
                        className={`tab-item ${tab === "revisional-material" ? "active" : ""}`}
                        onClick={() => this.goToTab("revisional-material")}
                    >
                        Revisional Material
                    </div>

                    <div
                        className={`tab-item ${tab === "video-classes" ? "active" : ""}`}
                        onClick={() => this.goToTab("video-classes")}
                    >
                        Video Classes
                    </div>

                    <div
                        className={`tab-item ${tab === "practice" ? "active" : ""}`}
                        onClick={() => this.goToTab("practice")}
                    >
                        Practice
                    </div>
                </div>

                {/* TAB CONTENT */}
                <div className="tab-content-box mt-4">

                    {/* PREVIOUS PAPERS */}
                    {tab === "previous-papers" && (
                        <div>
                            <h4>Previous Papers</h4>

                            {previousPapers.length > 0 ? (
                                <ul className="item-list">
                                    {previousPapers.map((p, i) => (
                                        <li key={i} className="item-card">
                                            {p.title}
                                        </li>
                                    ))}
                                </ul>
                            ) : (
                                <p>No previous papers available.</p>
                            )}
                        </div>
                    )}

                    {/* SHORT NOTES */}
                    {tab === "short-notes" && (
                        <div>
                       

                            {shortNotes ? (
                                <SyllabusPdfTable showPdf={true} pdfUrl={shortNotes} />
                            ) : (
                                <p>No short notes available.</p>
                            )}
                        </div>
                    )}

                    {/* REVISION MATERIAL */}
                    {tab === "revisional-material" && (
                        <div>


                            {revisionalMaterial ? (
                                <SyllabusPdfTable showPdf={true} pdfUrl={revisionalMaterial} />
                            ) : (
                                <p>No revisional material available.</p>
                            )}
                        </div>
                    )}

                    {/* VIDEO CLASSES */}
                    {tab === "video-classes" && (
                        <div className="video-grid">
                            {videos.length > 0 ? (
                                videos.map((vid, index) => (
                                    <div key={index} className="video-card">
                                        <iframe
                                            width="100%"
                                            height="200"
                                            src={vid.video_url}
                                            title={`Video ${index + 1}`}
                                            frameBorder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                            allowFullScreen
                                        ></iframe>
                                    </div>
                                ))
                            ) : (
                                <p>No videos available.</p>
                            )}

                        </div>
                    )}


                 {tab === "practice" && (
    <div>

        {practise.length > 0 ? (
            <div
                style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "20px"
                }}
            >
                {practise.map((exam, index) => (
                    <div
                        key={index}
                        className="border_pad_card"
                        style={{
                            width: "32%",
                            minWidth: "280px",
                            background: "#ffffff",
                            borderRadius: "14px",
                            border: "1px solid #e5e5e5",
                            padding: "18px",
                            boxShadow: "0 4px 10px rgba(0,0,0,0.08)",
                            transition: "0.3s",
                        }}
                    >
                        {/* ⭐ 7 COL (title + duration) + 5 COL (button) ⭐ */}
                        <div
                            style={{
                                display: "flex",
                                width: "100%",
                                alignItems: "center",
                                marginBottom: "12px"
                            }}
                        >
                            {/* LEFT — 7 Columns */}
                            <div style={{ width: "58.33%" }}>
                                <h5
                                    style={{
                                        margin: 0,
                                        fontSize: "17px",
                                        fontWeight: "600",
                                        color: "#222"
                                    }}
                                >
                                    {exam.title}
                                </h5>

                                <p
                                    style={{
                                        margin: "6px 0 0 0",
                                        fontSize: "14px",
                                        color: "#555"
                                    }}
                                >
                                    Duration:{" "}
                                    <strong>{exam.exam_duration_min} Min</strong>
                                </p>
                            </div>

                            {/* RIGHT — 5 Columns (centered button) */}
                            <div
                                style={{
                                    width: "41.66%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}
                            >
                                <button
                                    className="btn-custom-blue"
                                    style={{
                                        height: "34px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        whiteSpace: "nowrap",
                                        fontSize: "14px",
                                        fontWeight: "600",
                                        padding: "5px 20px",
                                        cursor: "pointer"
                                    }}
                                >
                                    {exam.is_completed
                                        ? "View Results"
                                        : "Start Practice"}
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        ) : (
            <p>No practice exams available.</p>
        )}

    </div>
)}






                </div>

            </Container>
        );
    }
}

export default withRouter(CBSEChapterDetailsSection);
